import React from 'react'
import ComboFilter from './ComboFilter.jsx'

/**
 * We are reusing the ComboFilter component and showing it a single time only here
 * and using it a filter builder.  Once the column, predicate (optional), and value
 * are set, the user has the option to turn this from a template to an Applied filter
 * by clicking "Add Filter" button.
 */
const FilterTemplate = ({ filtersList, addToAppliedFilters }) => {
  return (
    <ComboFilter filtersList={filtersList} addToAppliedFilters={addToAppliedFilters} />
  )
}

export default FilterTemplate
